export default __webpack_public_path__ + "static/media/astronaut-01.4b7ab262.svg";